import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import CheckoutConfirmView from 'chairisher/view/checkout/confirm';
import CheckoutPaymentView from 'chairisher/view/checkout/payment';
import CheckoutProductsView from 'chairisher/view/checkout/products';
import CheckoutShippingAddressView from 'chairisher/view/checkout/shippingaddress';
import CheckoutView from 'chairisher/view/checkout';
import Disclaimers from 'chairisher/view/product/disclaimers';
import ExpressCheckoutView from 'chairisher/view/checkout/expresscheckout';
import ProductModel from 'chairisher/model/product';

import { trackOrderCreatePageview } from 'chairisher/analytics/order';
import { getAmplitudeExperimentFlagMap } from 'chairisher/context/experiments';
import { getProductObjectArray } from 'chairisher/context/product';
import { getPurchaseObject } from 'chairisher/context/purchase';
import { exposeExperiment } from 'chairisher/thirdparty/experiments';
import { CheckoutPosition, logAmplitudeClickEvent } from 'chairisher/util/analytics';
import { isTouchDevice } from 'chairisher/util/mediaquery';

/**
 * Controller that binds actions for checkout
 */
class CartController extends BaseController {
    /** @inheritDoc */
    initControllerState() {
        super.initControllerState();

        const { products } = getPurchaseObject();
        if (products && products.length > 0) {
            // Only initialize checkout if there are products in cart
            const checkoutView = new CheckoutView({
                confirmView: new CheckoutConfirmView('#js-card-review-and-confirm'),
                expressCheckoutView: new ExpressCheckoutView(),
                paymentView: new CheckoutPaymentView('#js-card-payment-method'),
                productsView: new CheckoutProductsView('#js-card-products'),
                shippingAddressView: new CheckoutShippingAddressView('#js-card-shipping-address'),
            });

            checkoutView.initialize();
        }
    }

    bindPageAnalytics() {
        super.bindPageAnalytics();

        // @TODO (CHAIR-19441): Remove after test
        exposeExperiment(getAmplitudeExperimentFlagMap().CHECKOUT_UX_IMPROVEMENTS);

        trackOrderCreatePageview(ProductModel.bulkCreateFromArray(getProductObjectArray()));
    }

    /** @inheritdoc * */
    bindPageActions() {
        super.bindPageActions();

        const { products } = getPurchaseObject();
        if (products && products.length) {
            Disclaimers.render(products);
        }

        const $buyerGuaranteeLink = $('.js-buyer-guarantee-link');
        if (isTouchDevice()) {
            $buyerGuaranteeLink.on('click', (e) => {
                e.preventDefault();
                $('#js-buyer-guarantee-modal').modal();
            });

            $('.js-learn-more-link').on('click', (e) => this.trackBuyerGuaranteeLinkClick(e));
        } else {
            $buyerGuaranteeLink.on('click', (e) => this.trackBuyerGuaranteeLinkClick(e));
        }
    }

    /**
     * Sends analytics data related to the buyer guarantee link
     * @param {Event} e the event that called this function
     */
    trackBuyerGuaranteeLinkClick(e) {
        const $link = $(e.currentTarget);

        logAmplitudeClickEvent('Buyer Guarantee', CheckoutPosition.CART, $link.attr('href'));
    }
}

export default CartController;
